/**
 * FieldParts — shared styled primitives for label, helper, and error text
 * used by all input shims (FormikInput, Textarea, SearchInput).
 *
 * Uses CSS vars (Primitives-tier tokens), NOT ThemeProvider.
 * Mirrors the FieldLabel/FieldHelper pattern in BaseComponents.tsx
 * but is independently importable without the full theme context.
 */
import styled from 'styled-components'

export const FieldLabel = styled.label`
  font-family: var(--font-sans);
  font-size: var(--fs-body);
  font-weight: 500;
  color: var(--neutral-800);
  display: block;
`

export const RequiredIndicator = styled.span`
  color: var(--error-500);
  margin-left: 2px;
`

/**
 * FieldHelper renders error/helper text absolutely positioned below the field.
 * This prevents layout shift ("jump") when validation errors appear — the text
 * sits in the existing gap space between fields rather than pushing content down.
 * Accessibility is preserved: role="alert" + aria-describedby still work with
 * absolute positioning, and the text remains in the DOM reading order.
 * Remove position:absolute if a future design requires inline error text.
 */
export const FieldHelper = styled.span<{$error?: boolean}>`
  font-size: var(--fs-caption);
  color: ${({$error}) => ($error ? 'var(--error-500)' : 'var(--neutral-600)')};
  display: block;
  position: absolute;
  right: 0;
  top: 100%;
  margin-top: var(--space-1);
  ${({$error}) => $error && 'text-align: right;'}
`

export const FieldWrapper = styled.div<{$fullWidth?: boolean}>`
  display: flex;
  flex-direction: column;
  position: relative;
  ${({$fullWidth}) => $fullWidth !== false && 'width: 100%;'}
`
